<template>
  <div class="px-2 pt-3">
    <h3 class="text-h6 px-2">{{ title }}</h3>
    <v-list nav class="px-0 larger-list">
      <template v-if="items?.length">
        <v-list-item
          v-for="item in items"
          :key="item.key"
          exact
          :to="item.routerLink"
          data-testid="notification-item"
        >
          <v-list-item-title
            class="text-grey better-line-height font-weight-regular"
          >
            {{ item.title }}
          </v-list-item-title>
          <v-list-item-title class="better-line-height font-weight-regular">
            {{ item.text }}
          </v-list-item-title>
          <v-list-item-subtitle class="better-line-height">
            {{ item.subtitle }}
          </v-list-item-subtitle>
        </v-list-item>
      </template>
      <v-list-item v-else>
        <v-list-item-title class="font-weight-regular">
          All Caught Up
          <v-icon color="orange" class="mb-1" :icon="mdiPartyPopper" />
        </v-list-item-title>
      </v-list-item>
    </v-list>
    <div class="pa-3">
      <app-button
        variant="outlined"
        color="primary"
        exact
        block
        class="text-none"
        :data-testid="`view-all-${title}`"
        :to="viewAllLink"
      >
        View All {{ title }}
      </app-button>
    </div>
  </div>
</template>

<script setup>
import { mdiPartyPopper } from "@mdi/js";

defineProps({
  title: { type: String, required: true },
  items: { type: Array, required: true },
  viewAllLink: { type: Object, required: true }
});
</script>
